//LEXSTYLE 
//Alex Lopez - Public common js
jQuery(function($){ 
    "use strict";
    
    $(".card").fadeIn(300);
	
});